import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.danger};
  margin-top: 8px;
`;

const InputFeedback = ({ error }) => {
  return error ? <StyledContainer>{error}</StyledContainer> : null;
};

export default InputFeedback;
